enum CurrencyConverts {
  USD = "USD",
  EUR = "EUR",
  RUB = "RUB",
}

export default CurrencyConverts;
